import { BaseApiRepository } from './base-api-repository';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { inject } from '@angular/core';

export class RegistrationApiRepository extends BaseApiRepository {
  protected readonly store = inject(Store);

  constructor() {
    super();
  }

  get<T>(path: string, queryParams?: HttpParams): Observable<T> {
    return super.sendGetRequest<T>(path, queryParams);
  }

  post<P, T>(
    path: string,
    payload: P,
    queryParams?: HttpParams,
  ): Observable<T> {
    return super.sendPostRequest<P, T>(path, payload, queryParams);
  }
}
